/**
 * The `list_filter.sort_by` ListCounterparties takes for each customers column, by column
 * id. The status column orders active above inactive (descending), by the contracts with
 * the selected company and its children. «№» (the row number), «Тип» (the same label
 * on every row), «БИН» and «Договор» do not sort.
 */
export const CUSTOMER_SORT_FIELDS: Readonly<Record<string, string>> = {
  name: "name",
  status: "status",
  created_at: "created_at",
  phone_number: "contact_phone",
  contact_name: "contact_name",
};
